import axios from "axios";
import { config } from "../config";

export const API_BASE = config.apiBaseUrl;

export const instance = axios.create({
  baseURL: API_BASE,
  timeout: 60000,
  withCredentials: true
});

export const fetcher = <T>(url: string, options?: RequestInit) =>
  fetch(
    API_BASE + url,
    options
      ? {
          cache: "no-store",
          credentials: "include",
          headers: {
            "Content-Type": "application/json"
          },
          ...options
        }
      : {
          cache: "no-store",
          credentials: "include",
          headers: {
            "Content-Type": "application/json"
          }
        }
  )
    .then((res) => {
      return res.text();
    })
    .then((d) => {
      return d
        ? (JSON.parse(d) as T | { error: { message: string; status: number } })
        : null;
    })
    .then((res: T | { error: { message: string; status: number } }) => {
      if (res && typeof res === "object" && "error" in res)
        throw new Error(res.error.message || "Unknown error");

      return res;
    });
